module.exports = __webpack_public_path__ + "static/img/img-008.33d4bef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-008.png
// module id = R+5U
// module chunks = 1